import React from "react";
import {
  // HashRouter,
  // createBrowserRouter,
  createHashRouter,
} from "react-router-dom";
import Presentation from "../views/Presentation";
import Prerequis from "../views/Prerequis";
import PaiementDirect from "../views/PaiementDirect";
import PaiementDiffere from "../views/PaiementDiffere";
import PaiementRedirige from "../views/PaiementRedirige";
import Reversement from "../views/Reversement";
import PaiementStatus from "../views/PaiementStatus";
import NewDocsPage from "../views/NewDocsPage";
import SoldeService from "../views/SoldeService";
import CallbackURL from "../views/CallbackUrl";

const Router = createHashRouter([
  {
    path: "/prerequis",
    element: <Prerequis />,
  },
  {
    path: "/",
    element: <Presentation />,
  },

  {
    path: "/paiement_direct",
    element: <PaiementDirect />,
  },
  {
    path: "/paiement_status",
    element: <PaiementStatus />,
  },
  {
    path: "/reversement",
    element: <Reversement />,
  },
  {
    path: "/paiement_differe",
    element: <PaiementDiffere />,
  },
  {
    path: "/paiement_redirige",
    element: <PaiementRedirige />,
  },
  {
    path: "/solde",
    element: <SoldeService />,
  },
  {
    path: "/callback_url",
    element: <CallbackURL />,
  },
  {
    path: "/docs",
    element: <NewDocsPage />,
  },
]);

export default Router;
